import { render, staticRenderFns } from "./EventReportContent.vue?vue&type=template&id=2bc47809&scoped=true"
import script from "./EventReportContent.vue?vue&type=script&lang=ts"
export * from "./EventReportContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc47809",
  null
  
)

export default component.exports